import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceImportService } from "./service";

type InsuranceImport = insuranceImportApiSpec.InsuranceImport;

export const submitInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.post<InsuranceImport>(
    `/${insuranceImportId}/submit`
  );

  return data;
};
